var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{staticStyle:{"overflow":"hidden"},attrs:{"padding":""}},[_c('div',{key:_vm.lastTimeStamp,staticClass:"row q-mb-xs q-col-gutter-md"},[_c('iframe',{staticStyle:{"position":"absolute","width":"100%","height":"100%"},attrs:{"src":"https://www.flow-solutions.com/insight_library"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }